import { createVanIconComponent } from "./van/index.js";
const FriendsOutlined = createVanIconComponent("friends-o");
export default FriendsOutlined;
